/** User preference key: when set to an importId, the file-filter tour will auto-show on Transactions tab when that file is selected. */
export const TRANSACTIONS_FILE_FILTER_TOUR_PENDING_IMPORT_ID_KEY =
  'transactions-file-filter-tour-pending-importId';
/**
 * Legacy user preference key: when true, the file-filter tour has been shown for this user.
 * Kept for backwards compatibility / migration to provider-specific keys below.
 */
export const TRANSACTIONS_FILE_FILTER_TOUR_SHOWN_KEY =
  'transactions-file-filter-tour-shown';

/** User preference key: when true, the Excel file-filter tour has been shown for this user. */
export const TRANSACTIONS_FILE_FILTER_TOUR_SHOWN_EXCEL_KEY =
  'transactions-file-filter-tour-shown-excel';

/** User preference key: when true, the Receipts file-filter tour has been shown for this user. */
export const TRANSACTIONS_FILE_FILTER_TOUR_SHOWN_RECEIPTS_KEY =
  'transactions-file-filter-tour-shown-receipts';

/** User preference key: when true, the Ready to Post tab onboarding tour has been shown for this user. */
export const TRANSACTIONS_READY_TO_POST_TOUR_SHOWN_KEY =
  'transactions-ready-to-post-tour-shown';

/** User preference key: when true, the receipts entity onboarding tour has been shown for this user. */
export const RECEIPTS_ONBOARDING_TOUR_SHOWN_KEY =
  'receipts-onboarding-tour-shown';

/** User preference key prefix for organisation details active tab. Suffix with organisationId for per-entity persistence. */
export const ORGANISATION_DETAILS_ACTIVE_TAB_KEY_PREFIX =
  'organisation-details-active-tab';

/** User preference key prefix: when set (value truthy), the receipts "Before you scan" checklist has been completed for this entity (tax rates + COA done/ignored + at least 1 receipt scanned). Suffix with organisationId. */
export const RECEIPTS_BEFORE_SCAN_CHECKLIST_DONE_KEY_PREFIX =
  'receipts-before-scan-checklist-done';

/** User preference key prefix: when true, the user chose "Skip for now" for chart of accounts in the receipts "Before you scan" checklist. Suffix with organisationId. */
export const RECEIPTS_BEFORE_SCAN_COA_SKIPPED_KEY_PREFIX =
  'receipts-before-scan-coa-skipped';

/** User preference key prefix: when true, receipts scan uses "Lines grouped by tax code"; when false, "Individual lines". Suffix with organisationId. */
export const RECEIPTS_GROUP_BY_TAX_CODE_KEY_PREFIX =
  'receipts-group-by-tax-code';

/** User preference key prefix: when true, receipt scans map extracted line items. Suffix with organisationId. */
export const RECEIPTS_MAP_ITEMS_KEY_PREFIX = 'receipts-map-items';

/** User preference key prefix: multi-currency handling for receipt scans (`CONVERT` | `STOP`). Suffix with organisationId. */
export const RECEIPTS_MULTI_CURRENCY_MODE_KEY_PREFIX =
  'receipts-multi-currency';

/** User preference key for transactions table page size. Suffix with organisationId for per-entity value. */
export const PAGE_SIZE_EXCEL_TRANSACTIONS = 'page-size-excel-transactions';
